import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Heart, FileText, Zap, Lock } from 'lucide-react';
export function PostValueCTA() {
  return <section className="py-10 md:py-20 px-5 bg-brand-navy" data-id="element-150">
      <div className="max-w-3xl mx-auto text-center" data-id="element-151">
        <FadeIn data-id="element-152">
          <Heart className="w-10 h-10 text-brand-orange mx-auto mb-4" data-id="element-153" />
          <h2 className="font-serif text-3xl md:text-4xl text-white font-bold mb-4" data-id="element-154">
            Tu familia merece más calma.
          </h2>
          <p className="font-sans text-base text-slate-300 leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-155">
            Hoy puedes dar el primer paso hacia un hogar con menos gritos, menos
            culpa y más conexión.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-156">
          <CTAButton mainText="SÍ, QUIERO EL KIT DIGITAL CALMA EN CASA" subText="Acceso inmediato al Sistema CVR por solo $7" data-id="element-157" />
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-4 text-xs text-slate-400" data-id="element-158">
            <span className="inline-flex items-center gap-1" data-id="element-159">
              <Zap className="w-3.5 h-3.5" data-id="element-160" />
              Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-161">
              <FileText className="w-3.5 h-3.5" data-id="element-162" />
              Kit Digital multidispositivo
            </span>
            <span className="inline-flex items-center gap-1" data-id="element-163">
              <Lock className="w-3.5 h-3.5" data-id="element-164" />
              Pago seguro
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}